module.exports = {
	baseUrl : '/',
	staticUrl : 'https://d1oo4riy5et4sg.cloudfront.net/v3-1',
	globalUrl : 'https://garden-eight.com',
	cdnUrl    : 'https://d1oo4riy5et4sg.cloudfront.net/v3-1',
	cdnDomain : 'https://d1oo4riy5et4sg.cloudfront.net',
	s3Url     : 'https://gdn8.s3.ap-northeast-1.amazonaws.com/v3-1',
	s3Domain  : 'https://gdn8.s3.ap-northeast-1.amazonaws.com',
	dist      : 'dist/prod',
	api : {
		response : 'https://garden-eight.com/_api/chatApi/getOpenAIResponse/',
		setting  : 'https://garden-eight.com/_api/chatApi/json/setting.json',
		faq      : 'https://garden-eight.com/_api/chatApi/json/faq.json',
		notion_page : 'https://garden-eight.com/_api/chatApi/_getNotionPage.php'
	},
	pwa : true
}